import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import moment from 'moment';

import { v1BaseUrl } from './config.js';
import { navBarHtml, loader, showLoader, hideLoader } from '/js/navigation.js';
import { navigate, openModalRoute } from '/js/router.js';

import { userData, resendEmailConfirmation } from '/js/accounts.js';
import { mkToast } from '@shared/js/toasts.js';
import { renderAnnouncements } from '@shared/js/announcements.js';

// Wrap a URL for safe use inside a CSS url("...") declaration — quotes,
// backslashes and closing parens are percent-encoded so the value can't
// escape the declaration.
function cssUrl(url) {
  return `url("${String(url || '').replace(/["\\)]/g, (c) => encodeURIComponent(c))}")`;
}

export function renderLibrary(alertClass = null, alertMessage = null) {
  let app = $("#app");

  app.empty();
  app.append(navBarHtml("My Vault"));

  let container = $('<div class="container pt-4 pb-5 vault-container"></div>');
  
  if (!userData.emailVerified) {
	  alertClass = "danger";
	  alertMessage = `Your email address (${userData.email}) needs to be verified before you can stream or redeem shows. Please check your email for the link we sent you in order to verify your email address. Need a new link? <a id="resendEmailConfirmationBtn" class="btn btn-link p-0 pb-1">Resend Email</a>.`;
  }

  let tiles = $(
	'<div class="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-6 g-3 mt-auto"></div>'
  );
  
  let alertBox = null;
	if (alertMessage) {
	  alertBox = $(`<div class="alert alert-${alertClass} mt-3 alert-dismissible fade show" role="alert">${alertMessage}<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`);
	  container.append(alertBox);
	}
  // Add skeleton loaders
	for (let i = 0; i < 10; i++) {
	  let skeletonCard = $('<div class="card rounded-3 bg-danger-subtle sv-show-card" aria-hidden="true"></div>');
	  let skeletonImg = $('<div class="card-img-top placeholder-glow" style="background-color: rgba(255, 255, 255, 0.1); padding-bottom: 150%;"></div>');
	  let skeletonCardBody = $('<div class="card-body"></div>');
	  let skeletonCardTitle = $('<h5 class="card-title placeholder-glow"><span class="placeholder" style="width:' + (50 + Math.random() * 50) + '%"></span></h5>');
	  
	  let widths = [
		40 + Math.random() * 60,
		20 + Math.random() * 30,
		20 + Math.random() * 30,
		30 + Math.random() * 50,
		50 + Math.random() * 50
	  ];
	  
	  let sumWidth = widths.reduce((a, b) => a + b, 0);
	  if (sumWidth > 100) {
		widths[widths.length - 1] -= sumWidth - 100;
	  }
	  
	  let skeletonCardText = $(`
		<p class="card-text placeholder-glow">
		  <span class="placeholder" style="width:` + widths[0] + `%"></span>
		  <span class="placeholder" style="width:` + widths[1] + `%"></span>
		  <span class="placeholder" style="width:` + widths[2] + `%"></span>
		  <span class="placeholder" style="width:` + widths[3] + `%"></span>
		  <span class="placeholder" style="width:` + widths[4] + `%"></span>
		</p>
	  `);
	  
	  skeletonCardBody.append(skeletonCardTitle, skeletonCardText);
	  skeletonCard.append(skeletonImg, skeletonCardBody);
	  tiles.append($('<div class="col"></div>').append(skeletonCard));
	}

  container.append(tiles);
  app.append(container);
  renderAnnouncements(container);
  
  if (!userData.emailVerified) {
		$("#resendEmailConfirmationBtn").on('click', function(event) {
			resendEmailConfirmation();
		});
	}

  fetchShows().then((shows) => {
	// Empty the tiles container to remove skeleton loaders
	tiles.empty();

	if (shows.length === 0) {
	  // Empty state with a direct path to the action that fills the vault.
	  const noTitlesMessage = $('<div class="alert alert-info mt-3" role="alert"></div>')
		.text('Your vault is empty. Redeem a show code to add your first show.');
	  const redeemCta = $('<div class="mt-2"><button type="button" class="btn btn-sm btn-primary"><i class="bi bi-plus-lg me-1"></i>Redeem a Code</button></div>');
	  redeemCta.find('button').on('click', () => openModalRoute('redeem'));
	  noTitlesMessage.append(redeemCta);
	  container.append(noTitlesMessage);
	} else {

	shows.forEach((show) => {
	  // Data
	  let _id = show.id;
	  let _coverArt = show.coverArt;
	  let _title = show.title;
	  let _subtitle = show.subtitle;
	  let _category = show.category;
          let _monthYear = moment(show.performanceDate).format("MMMM YYYY");
          let _release = moment(show.releaseAt).format("MMMM Do");
          let _href = '/shows/' + encodeURIComponent(_id);

	  // Rendering. The card is a real anchor so it works with the keyboard,
	  // middle-click and cmd/ctrl-click; text content is set with .text()
	  // so show metadata can never inject markup.
	  let col = $('<div class="col"></div>').attr('id', 'show_' + _id);
	  let card = $(
		'<a class="card rounded-3 overflow-hidden h-100 bg-danger-subtle sv-show-card text-body text-decoration-none"></a>'
	  ).attr('href', _href);
	  let image = $('<div class="card-img-top" style="background-size: cover; background-position: center; padding-bottom: 150%;"></div>')
		.css('background-image', cssUrl(_coverArt));
	  let releaseNote = $('<div class="bg-black p-2 mb-2 fs-6 text-center"><span class="text-warning fw-bold"></span></div>');
	  releaseNote.find('span').text('Available ' + _release);
	  let unavailableFlag = $('<div class="bg-black p-2 mb-2 fs-6 text-center"><span class="text-warning fw-bold">Unavailable</span></div>');
	  let body = $('<div class="card-body d-flex flex-column justify-content-between"></div>');
	  let top = $('<div></div>');
	  	let title = $('<span class="d-block fs-4 lh-sm fw-semibold text-light"></span>').text(_title);
	  	let subtitle = $('<span class="d-block fs-5 text-light"></span>').text(_subtitle);
	  let bottom = $('<div></div>');
                let description = $('<span class="d-block mt-2 mb-1 fs-6"></span>').text(`${_category} · ${_monthYear}`);
	  top.append(title, subtitle);
	  bottom.append(description);
	  body.append(top, bottom);
          const released = moment(show.releaseAt).unix() <= moment().unix();

          if (!released) {
            // Show is coming soon
            card.addClass('grayscale-custom');
            card.append(image, releaseNote, body);
          } else if (!show.ready) {
            // Release date passed but video not yet processed
            card.addClass('grayscale-custom');
            card.append(image, unavailableFlag, body);
          } else {
            // Fully available
            card.removeClass('grayscale-custom');
            card.append(image, body);
          }
	  col.append(card);
	  tiles.append(col);

	  // Selectors
	  card.on('click', function(event) {
                  // Let the browser handle new-tab/new-window clicks natively.
                  if (event.metaKey || event.ctrlKey || event.shiftKey) {
                        return;
                  }
                  event.preventDefault();
                if (!userData.emailVerified) {
                        mkToast('vault', 'danger', 'Error', 'You must verify your email before watching a show!', 10000);
                        return;
                  }
                  // Route to /shows/:id so the URL reflects the page. The
                  // details page handles pre-release / processing display.
                  navigate(_href);
	  });
	});

		container.append(tiles);
	}
  }).catch((error) => {
	  console.error('Error fetching shows:', error);
	  // Replace the skeletons with an actionable error state instead of
	  // leaving placeholder cards glowing forever.
	  tiles.empty();
	  const errorBox = $('<div class="alert alert-danger mt-3" role="alert"></div>')
		.text("We couldn't load your vault. Please check your connection and try again.");
	  const retryBtn = $('<div class="mt-2"><button type="button" class="btn btn-sm btn-outline-light"><i class="bi bi-arrow-clockwise me-1"></i>Retry</button></div>');
	  retryBtn.find('button').on('click', () => renderLibrary());
	  errorBox.append(retryBtn);
	  container.append(errorBox);
	});
}

function fetchShows() {
  return new Promise((resolve, reject) => {
      $.ajax({
          url: v1BaseUrl + "account/shows",
          type: "GET",
          svErrorMode: 'default',
          xhrFields: {
                withCredentials: true
          },
	  dataType: "json",
	  success: function (data) {
		if (data.shows) {
		  resolve(data.shows);
		} else {
		  reject(new Error("No shows found in the response"));
		}
	  },
	  error: function (jqXHR, textStatus, errorThrown) {
		// Handle errors here
		console.error("Error fetching shows: " + textStatus, errorThrown);
		reject(new Error("Error fetching shows: " + textStatus));
	  },
	});
  });
}


// Simulated API fetch
// function fetchShows() {
//   return new Promise((resolve) => {
// 	const shows = [
// 	  {
// 		id: "481539dd-f56b-48e7-bd06-2583ef9a3b49",
// 		coverArt: "https://s3.amazonaws.com/prdv2-dt-client/uploads/uqwhAK3jFcQ05cMKuJ0KRckC320wVAiR.jpg",
// 		title: "Mamma Mia",
// 		subtitle: "Cast A",
// 		category: "Musical",
// 		season: "Fall",
// 		year: 2021,
// 	  },
// 	  {
// 		  id: "481539dd-f56b-48e7-bd06-2583ef9a3b50",
// 		  coverArt: "https://s3.amazonaws.com/prdv2-dt-client/uploads/uqwhAK3jFcQ05cMKuJ0KRckC320wVAiR.jpg",
// 		  title: "Mamma Mia",
// 		  subtitle: "Cast B",
// 		  category: "Musical",
// 		  season: "Fall",
// 		  year: 2021,
// 		}
// 	];
// 	resolve(shows);
//   });
// }